import { render, staticRenderFns } from "./product-field.vue?vue&type=template&id=113367a6&"
import script from "./product-field.vue?vue&type=script&lang=ts&"
export * from "./product-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports